var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardClub(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.51043 3.60927C7.3783 3.60927 7.25313 3.62252 7.13491 3.63576C7.37135 3.27152 7.51043 2.84106 7.51043 2.38411C7.51043 1.06623 6.39082 0 5.00695 0C3.62309 0 2.50348 1.06623 2.50348 2.38411C2.50348 2.84768 2.64256 3.27152 2.879 3.63576C2.75382 3.61589 2.62865 3.60927 2.50348 3.60927C1.11961 3.60927 0 4.6755 0 5.99338C0 7.31126 1.11961 8.37748 2.50348 8.37748C3.35188 8.37748 4.09597 7.97351 4.54798 7.36424C4.5758 8.46358 4.21419 9.33113 3.51182 10H6.48818C5.79277 9.33113 5.43115 8.46358 5.45202 7.36424C5.90403 7.97351 6.64812 8.37748 7.49652 8.37748C8.88039 8.37748 10 7.31126 10 5.99338C10 4.6755 8.88734 3.60927 7.51043 3.60927Z",
    fill: "url(#paint0_linear_7280_21033)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7280_21033",
    x1: 1.66711,
    y1: 2.19801,
    x2: 8.02075,
    y2: 8.87047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#454545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardClub);
export default __webpack_public_path__ + "static/media/cardClub.bf1c29d053f63d0615749328c216defe.svg";
export { ForwardRef as ReactComponent };